var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free Facebook Logo Icon - Free Download Logos Logo Icons _ IconScout-24 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.92052 3.95325H11.0774V1.99633C10.5173 1.93808 9.95446 1.90932 9.39129 1.91017C7.71744 1.91017 6.57282 2.93171 6.57282 4.80248V6.41479H4.68359V8.60556H6.57282V14.2179H8.83744V8.60556H10.7205L11.0036 6.41479H8.83744V5.01787C8.83744 4.37171 9.00975 3.95325 9.92052 3.95325Z",
    fill: "#4B4AD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteFacebook);
export default __webpack_public_path__ + "static/media/website-facebook.ee64e88dc3319b279868b975f1919f99.svg";
export { ForwardRef as ReactComponent };